"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventHandlerRegisteredEventArgs = void 0;
const EventType_1 = require("../EventType");
class EventHandlerRegisteredEventArgs {
    constructor(eventHandlerId) {
        this.eventHandlerId = eventHandlerId;
        this.__type = EventType_1.EventType.EventHandlerRegistered;
        this.__typeName = "EventHandlerRegistered";
    }
}
exports.EventHandlerRegisteredEventArgs = EventHandlerRegisteredEventArgs;
